import React from 'react';
import PropTypes from 'prop-types';
import { config } from '../../Configs';
import { RecaptchaAction } from '../../Enums/recaptcha';
import { useTurnstileWidget } from '../../Hooks/useTurnstileWidget';

const TurnstileInvisibleCaptcha = props => {
  const {
    locale,
    onExpired,
    onError,
    onLoaded,
    onResolved,
    tabindex,
    captchaRef,
    theme: themeMode,
    action,
    size
  } = props;

  const container = useTurnstileWidget({
    action,
    captchaRef,
    disabledCaptcha: config.turnstile.invisible.disableValidation,
    execution: 'execute',
    locale,
    onExpired,
    onError,
    onLoaded,
    onResolved,
    siteKey: config.turnstile.invisible.siteKey,
    size,
    tabindex,
    theme: themeMode
  });

  if (
    config.turnstile.disableValidation ||
    config.turnstile.invisible.disableValidation
  ) {
    return <></>;
  }

  const ownStyle = {
    width: 1,
    height: 1,
    overflow: 'hidden',
    pointerEvents: 'none'
  };

  return <div ref={container} style={{ ...ownStyle, ...props.style }} />;
};

TurnstileInvisibleCaptcha.propTypes = {
  locale: PropTypes.string,
  onExpired: PropTypes.func,
  onError: PropTypes.func,
  onResolved: PropTypes.func,
  onLoaded: PropTypes.func,
  style: PropTypes.object,
  tabindex: PropTypes.number,
  theme: PropTypes.oneOf(['auto', 'light', 'dark']),
  size: PropTypes.oneOf(['invisible']),
  visible: PropTypes.bool,
  action: PropTypes.oneOf(Object.values(RecaptchaAction))
};

TurnstileInvisibleCaptcha.defaultProps = {
  locale: 'es',
  onExpired: () => {},
  onError: () => {},
  onLoaded: () => {},
  onResolved: () => {},
  tabindex: 0,
  theme: 'auto',
  size: 'invisible',
  visible: true,
  action: 'no_action'
};

export default TurnstileInvisibleCaptcha;
